// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styled from 'styled-components';

import NotificationPopup from '../NotificationPopup/';
import LabBubbleDeployingIcon from '../../../assets/images/header-lab-bubble-deploying-icon.svg';
import LabBubbleErrorIcon from '../../../assets/images/header-lab-bubble-error-icon.svg';
import Center from '../../../components/Center';
import IconButton from '../../../components/IconButton';
import Avatar from '../../../components/Avatar';
import MemberPopup from '../MemberPopup';
import LanguagePopup from './LanguagePopup';
import UserIcon from '../../../assets/images/not_signed_in_default.svg';
import UserActiveIcon from '../../../assets/images/not_signed_in_hover.svg';

interface MenuItemProps {
  active: boolean;
}
interface IconLinkProps extends MenuItemProps {
  activeIcon: string;
  text: string;
  icon: string;
}

const otherS = {
  Container: styled.header`
    display: flex;
    align-items: stretch;
    width: 100%;
    height: 70px;
    padding: 0 37px;
    background-color: #313131;
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
  `,
  LanguagePopup: styled(LanguagePopup)`
    position: absolute;
    top: calc(100% + 5px);
    left: 50%;
    transform: translateX(-50%);
  `,
  NotificationPopup: styled(NotificationPopup)`
    min-height: calc(100vh - 70px - 75px);
    height: calc(100% - 70px);
    position: fixed;
    right: 0;
    top: 70px;

    &.alert-enter {
      transform: translateX(100%);
    }
    &.alert-enter-active {
      transform: translateX(0);
      transition: transform 300ms;
    }
    &.alert-exit {
      transform: translateX(0);
    }
    &.alert-exit-active {
      transform: translateX(100%);
      transition: transform 300ms;
    }
  `,
  Logo: styled.img`
    align-self: center;
    width: 186px;
    margin-right: 18px;
  `,
  Avatar: styled(Avatar)`
    cursor: pointer;
  `,
  AvatarContainer: styled.div`
    margin-left: 21px;
    align-self: center;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  `,
  MenuItem: styled(Link)<{ active: boolean }>`
    align-self: stretch;
    flex-shrink: 0;
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    ${props => props.active && { backgroundColor: '#707070' }}
    ${props => !props.active && `
      &:hover {
        background-color: #444444;
      }
    `}
  `,
  ActionItems: styled.div`
    display: flex;
    align-items: stretch;
    margin-left: auto;
  `,
  ActionItem: styled.div<{ active: boolean }>`
    flex-shrink: 0;
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    ${props => props.active && { backgroundColor: '#707070' }}
    ${props => !props.active && `
      &:hover {
        background-color: #444444;
      }
    `}
  `,
  UserIcon: styled.div`
    width: 32px;
    height: 32px;
    background-image: url(${UserIcon});
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: 4px;
  `,
  LoginText: styled.span`
    font-size: 14px;
    line-height: 20px;
    color: #C9C9C9;
  `,
  IconLink: styled(({
    className,
    active,
    activeIcon,
    text,
    icon,
    style,
    to
  }: IconLinkProps & LinkProps & React.ComponentProps<'a'>) => {
    return (
      <Center as={Link} to={to} className={className} style={style}>
        <IconButton
          active={active}
          icon={icon}
          activeIcon={activeIcon}
          text={text}
        />
      </Center>
    );
  }
  )`
    align-self: stretch;
    width: 85px;

    ${({ active }) => {
      if (active) {
        return {
          backgroundColor: '#707070'
        };
      }
      return `
        &:hover {
          background-color: #444444;
        }
      `;
    }}
  `,
  IconWrapper: styled.div`
    display: flex;
    position: relative;
  `,
  Badge: styled.div`
    background: #00C6AD;
    position: absolute;
    top: 0;
    right: 0;
    width: 13px;
    height: 13px;
    border-radius: 50%;
  `,
  ExamBadge: styled.div`
    background: #00C6AD;
    position: absolute;
    top: -3px;
    right: -6px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
  `,
  BadgeDeploying: styled.img.attrs({ src: LabBubbleDeployingIcon, alt: 'deploying bubble icon' })`
    position: absolute;
    top: 0;
    right: 0;
    width: 13px;
    height: 13px;
    animation-name: spin;
    animation-duration: 5000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }
  `,
  BadgeError: styled.img.attrs({ src: LabBubbleErrorIcon, alt: 'error bubble icon' })`
    position: absolute;
    top: 0;
    right: 0;
    width: 13px;
    height: 13px;
  `,
  MemberPopup: styled(MemberPopup)`
    top: calc(100% - 2px);
    right: -3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
}

const S = {
  ...otherS,
  LoginContainer: styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      ${otherS.UserIcon} {
        background-image: url(${UserActiveIcon});
      }

      ${otherS.LoginText} {
        color: white;
      }
    }
  `,
}

export { S as default }
